// Formats US phone numbers into standard formats:
export const formatPhone = (phone?: string) =>
  String(phone ?? '').replace(
    /^\s*(\+?1)?\D*(\d{3})\D*(\d{3})\D*(\d{4})\s*$/,
    (_: string, cc = '', a = '', b = '', c = '') => `${cc ? (cc.startsWith('+') ? '+1 ' : '1 ') : ''}${a}-${b}-${c}`,
  );
